import React from 'react';

interface LoadingProps {
  fullScreen?: boolean;
  size?: 'small' | 'medium' | 'large';
  message?: string;
}

const Loading: React.FC<LoadingProps> = ({
  fullScreen = false,
  size = 'medium',
  message = '로딩 중...'
}) => {
  return (
    <div className={`loading-container ${fullScreen ? 'full-screen' : ''}`}>
      <div className="loading-content">
        <div className="spinner-container">
          <div className={`spinner spinner--${size}`}>
            <div className="spinner__dot"></div>
          </div>
        </div>
        {message && <p className="loading-message">{message}</p>}
      </div>
    </div>
  );
};

export default Loading;